/* WF-13 · AS-01…AS-03 — Aide et support.
   The section is new in v5; the switcher is build chrome, as elsewhere. */
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Tabs } from '@/ui'

export const AS_SURFACES = [
  { frame: 'AS-01', to: '', label: 'Aide et support' },
  { frame: 'AS-02', to: 'article', label: 'Guide' },
  { frame: 'AS-03', to: 'contact', label: 'Écrire au support' },
] as const

const surfacePath = (to: string) => `/aide${to ? '/' + to : ''}`

export default function AideShell() {
  const nav = useNavigate()
  const { pathname } = useLocation()
  const current = AS_SURFACES.find(s => pathname === surfacePath(s.to))?.to ?? ''
  return (
    <div style={{ display: 'grid', gap: 18, maxWidth: 900 }}>
      <nav aria-label="Aide et support" style={{ minWidth: 0 }}>
        <Tabs value={current} onChange={to => nav(surfacePath(to))}
          options={AS_SURFACES.map(s => [s.to, s.label] as [string, string])} />
      </nav>
      <Outlet />
    </div>
  )
}
